import EnrolPage from './enrol-page';

export default EnrolPage;
